import api from './api'

export const analyticsService = {
  getOverview: async () => {
    const res = await api.get('/admin/analytics/overview')
    return res.data.data
  },

  getRevenue: async (params = {}) => {
    // params: { from, to, groupBy: 'day'|'week'|'month' }
    const res = await api.get('/admin/analytics/revenue', { params })
    return res.data.data
  },

  getTopProducts: async (params = {}) => {
    const res = await api.get('/admin/analytics/top-products', { params })
    return res.data.data
  },

  getTopVendors: async (params = {}) => {
    const res = await api.get('/admin/analytics/top-vendors', { params })
    return res.data.data
  },

  getTopSearches: async (params = {}) => {
    // params: { limit, from, to }
    const res = await api.get('/admin/analytics/top-searches', { params })
    return res.data.data
  },

  getUsersGrowth: async (params = {}) => {
    const res = await api.get('/admin/analytics/users-growth', { params })
    return res.data.data
  },

  getActiveCarts: async (params = {}) => {
    const res = await api.get('/admin/analytics/active-carts', { params })
    return res.data
  },
}
